import React, { Dispatch, HTMLAttributes, useReducer } from 'react';
import { IAction, IReducer, IState } from '../../interfaces';
import reducer from '@src/reducer';

type IContext = [IState, Dispatch<IAction>];

const Store = React.createContext({} as IContext);

const useGlobalState = (): IContext => React.useContext(Store);
export default useGlobalState;


export const AppProvider: React.FC<HTMLAttributes<HTMLDivElement>> = ({ ...props }) => {
  const [globalState, dispatch] = useReducer<IReducer>(
    reducer,
    {
      widgets: undefined,
      apps: undefined,
      manage: undefined,
      permissions: undefined,
      login: undefined,
      session: undefined,
      is_impersonating: false,
      articles: undefined,
      pages: undefined,
      notice: undefined,
      orgs: undefined,
      requested: undefined,
      change_password: undefined,
      password_sent: undefined,
      users: undefined,
      search: undefined,
    }
  );

  return (
    <Store.Provider value={[globalState, dispatch]} >
      {props.children}
    </Store.Provider>
  );
};